export default __webpack_public_path__ + "static/media/dummyGoogle.8f5b2ad6.jpg";